<template>
  <div>
    <v-dialog
      v-model="viewDialogVisible"
      width="700px"
      no-click-animation
      scrollable
      :persistent="true"
    >
      <v-card class="window-card cardWrap">
        <!-- v-if="downLoading" -->
        <div style="height: 40px" v-if="downLoading">
          <v-progress-linear indeterminate color="green" height="18">
            <template>
              <p
                style="
                  line-height: 20px;
                  height: 20px;
                  text-align: center;
                  font-size: 16px;
                  color: #fff;
                  margin-bottom: 0;
                "
              >
                {{ title }}
              </p>
              <!-- <p style="color:red;font-size: 18px; line-height: 20px; height: 20px;">{{ title}}</p> -->
            </template>
          </v-progress-linear>
        </div>
        <p>{{ isView }}</p>

        <div class="content">
          <div style="margin-bottom: 10px">
            <p style="font-size: 13px; margin-bottom: 5px">需求类型</p>
            <el-select
              v-model="viewDialogData.requirement_type"
              style="width: 660px"
              size="small"
              :disabled="isdisabled"
            >
              <el-option
                v-for="item in requirement_type"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                style="width: 660px"
              />
            </el-select>
          </div>
          <div>
            <p style="font-size: 13px; margin-bottom: 5px">需求名称</p>
            <el-input size="small" v-model="viewDialogData.label" :disabled="isdisabled"></el-input>
          </div>

          <div>
            <el-collapse v-model="activeName" accordion>
              <el-collapse-item title="模型需求" name="1">
                <el-container style="position: relative">
                  <el-aside width="180px">
                    <el-tree
                      :data="TreeData"
                      :show-checkbox="false"
                      node-key="_id"
                      default-expand-all
                      :expand-on-click-node="false"
                      highlight-current
                      @node-click="clickNode"
                      ref="tree"
                      :current-node-key="currentId"
                    >
                      <span class="custom-tree-node" slot-scope="{ node, TreeData }">
                        <span
                          class="xuQiuText"
                          :style="{
                            width: node.data.type == 'requirement' ? '134px' : '100px',
                          }"
                          v-if="node.data.hasOwnProperty('type') && node.data.type == 'requirement'"
                        >
                          <!-- <q-tooltip>{{ data.requirement_model_name }}</q-tooltip> -->
                          <span>{{ node.data.requirement_model_name }}</span>
                        </span>

                        <span
                          class="xuQiuText"
                          :style="{
                            width: node.data.type == 'requirement' ? '134px' : '100px',
                          }"
                          v-else
                        >
                          <!-- <q-tooltip>{{ data.label }}</q-tooltip> -->
                          <span>{{ node.data.label }}</span>
                        </span>
                      </span>
                    </el-tree>
                  </el-aside>
                  <span
                    class="iconfont icon-xiazaidaoru"
                    @click="downAll"
                    style="
                      margin-left: 40px;
                      font-size: 14px;
                      cursor: pointer;
                      position: absolute;
                      right: 40px;
                    "
                    >一键下载</span
                  >
                  <el-container>
                    <el-main>
                      <div class="rightPageOne" v-if="componentShow">
                        <div style="margin-bottom: 10px">
                          <p style="font-size: 13px; margin-bottom: 5px">模型名称</p>
                          <el-input
                            size="small"
                            v-model="viewDialogData.requirement_model_name"
                            :disabled="isdisabled"
                            style="width: 400px"
                            class="namesAllStyle"
                          ></el-input>
                        </div>

                        <div style="margin-bottom: 10px">
                          <p style="font-size: 13px; margin-bottom: 5px">设备类型</p>
                          <el-select
                            v-model="viewDialogData.requirement_device_type"
                            style="width: 400px"
                            size="small"
                            :disabled="isdisabled"
                            class="namesAllStyle"
                          >
                            <el-option
                              v-for="item in requirement_device_type"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                              style="width: 400px"
                            />
                          </el-select>
                        </div>

                        <div style="margin-bottom: 10px">
                          <p style="font-size: 13px; margin-bottom: 5px">类型</p>
                          <el-select
                            v-model="viewDialogData.requirement_modmajor_type"
                            style="width: 400px"
                            size="small"
                            :disabled="isdisabled"
                            class="namesAllStyle"
                          >
                            <el-option
                              v-for="item in requirement_modmajor_type"
                              :key="item.code"
                              :label="item.name"
                              :value="item.code"
                              style="width: 400px"
                              class="namesAllStyle"
                            />
                          </el-select>
                        </div>
                        <div style="margin-bottom: 10px">
                          <p style="font-size: 13px; margin-bottom: 5px">尺寸</p>
                          <div
                            v-for="(item, index) in viewDialogData['requirement_size']"
                            :key="index"
                          >
                            <el-input
                              size="small"
                              v-model="item.label"
                              :disabled="isdisabled"
                              style="width: 140px; margin-right: 10px; margin-bottom: 5px"
                              class="namesAllStyle"
                            ></el-input>
                            <el-input
                              size="small"
                              v-model="item.value"
                              style="width: 240px"
                              :disabled="isdisabled"
                              class="namesAllStyle"
                            ></el-input>
                          </div>
                        </div>

                        <div v-if="viewDialogData.model_image || viewDialogData.model_file">
                          <p>
                            模型封面图:
                            <a :href="viewDialogData.model_image">{{
                              getImageName(viewDialogData.model_image)
                            }}</a>
                          </p>
                          <p>
                            模型:<a :href="viewDialogData.model_file">{{
                              getImageName(viewDialogData.model_file)
                            }}</a>
                          </p>
                        </div>

                        <div v-if="viewDialogData.mod_file_zip">
                          <p>
                            压缩包:
                            <a :href="viewDialogData.mod_file_zip">{{
                              getImageName(viewDialogData.mod_file_zip)
                            }}</a>
                          </p>
                        </div>

                        <div style="margin-bottom: 10px">
                          <p style="font-size: 13px; margin-bottom: 5px">尺寸图</p>
                          <p
                            v-for="(item, index) in viewDialogData['requirement_cad']"
                            :key="index"
                          >
                            <a :href="item.url">{{ item.name }}</a>
                          </p>
                        </div>

                        <div style="margin-bottom: 10px; overflow: hidden; height: auto">
                          <p style="font-size: 13px; margin-bottom: 5px">图片及视频</p>
                          <div
                            v-for="(item, index) in viewDialogData['requirement_imagevideo_list']"
                            :key="index"
                            class="imgVideoList"
                          >
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="item.name"
                              placement="top"
                            >
                              <p style="font-size: 12px" class="imgTitle">{{ item.name }}</p>
                            </el-tooltip>

                            <img
                              v-if="
                                item.url.lastIndexOf('.jpg') !== -1 ||
                                item.url.lastIndexOf('.png') !== -1 ||
                                item.url.lastIndexOf('.gif') !== -1 ||
                                item.url.lastIndexOf('.jpeg') !== -1
                              "
                              :src="item.url"
                              alt=""
                              style="width: 90px; height: 80px"
                            />
                            <video
                              v-if="item.url.lastIndexOf('.mp4') !== -1"
                              :src="item.url"
                              controls
                              muted
                              autoplay="false"
                              style="width: 90px; height: 80px"
                            ></video>
                            <div class="downWrap">
                              <div class="preWrap">
                                <span
                                  class="el-icon-zoom-in"
                                  style="margin-right: 10px"
                                  @click="preView(item)"
                                ></span>
                                <a class="el-icon-download" :href="item.url"></a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style="margin-bottom: 10px">
                          <p style="font-size: 13px; margin-bottom: 5px">附件</p>
                          <p
                            v-for="(item, index) in viewDialogData['requirement_annex']"
                            :key="index"
                          >
                            <a :href="item.url">{{ item.name }}</a>
                          </p>
                        </div>
                        <div style="margin-bottom: 10px">
                          <p style="font-size: 13px; margin-bottom: 5px">描述</p>
                          <el-input
                            size="small"
                            v-model="viewDialogData.requirement_des"
                            :disabled="isdisabled"
                            style="width: 400px;color"
                            type="textarea"
                            :autosize="{ minRows: 5 }"
                            class="describe"
                          ></el-input>
                        </div>
                      </div>
                      <div class="rightPageOne" v-else>
                        <div style="margin-bottom: 10px">
                          <p style="font-size: 13px; margin-bottom: 5px">名称</p>
                          <el-input
                            size="small"
                            v-model="checkNode.label"
                            :disabled="isdisabled"
                            style="width: 400px"
                            class="namesAllStyle"
                          ></el-input>
                        </div>

                        <div style="margin-bottom: 10px">
                         
                          <p style="font-size: 13px; margin-bottom: 5px">描述</p>
                          <el-input
                            size="small"
                            v-model="checkNode.component_des"
                            :disabled="isdisabled"
                            style="width: 400px"
                            type="textarea"
                            :autosize="{ minRows: 5 }"
                            class="describe"
                          ></el-input>
                        </div>
                        <div style="margin-bottom: 10px; overflow: hidden; height: auto">
                          <p style="font-size: 13px; margin-bottom: 5px">图片及视频</p>
                          <div
                            v-for="(item, index) in checkNode['component_imgvideo_list']"
                            :key="index"
                            class="imgVideoList"
                          >
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="item.name"
                              placement="top"
                            >
                              <p style="font-size: 12px" class="imgTitle">{{ item.name }}</p>
                            </el-tooltip>

                            <img
                              v-if="
                                item.url.lastIndexOf('.jpg') !== -1 ||
                                item.url.lastIndexOf('.png') !== -1 ||
                                item.url.lastIndexOf('.gif') !== -1 ||
                                item.url.lastIndexOf('.jpeg') !== -1
                              "
                              :src="item.url"
                              alt=""
                              style="width: 90px; height: 80px"
                            />
                            <video
                              v-if="item.url.lastIndexOf('.mp4') !== -1"
                              :src="item.url"
                              controls
                              muted
                              autoplay="false"
                              style="width: 90px; height: 80px"
                            ></video>
                            <div class="downWrap">
                              <div class="preWrap">
                                <span
                                  class="el-icon-zoom-in"
                                  style="margin-right: 10px"
                                  @click="preView(item)"
                                ></span>
                                <a class="el-icon-download" :href="item.url"></a>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div style="margin-bottom: 10px">
                          <p style="font-size: 13px; margin-bottom: 5px">附件</p>
                          <p
                            v-for="(items, index) in checkNode['component_annex_list']"
                            :key="index"
                          >
                            <a :href="items.url">{{ items.name }}</a>
                          </p>
                        </div>
                      </div>
                    </el-main>
                  </el-container>
                </el-container>
              </el-collapse-item>
              <el-collapse-item title="动画需求" name="2">
                <div>
                  <div
                    class="animationCon"
                    v-for="(item, index) in viewDialogData.requirement_animation"
                    :key="index"
                  >
                    <span class="animationTitle">动画{{ index + 1 }}</span>
                    <p style="font-size: 13px; margin-bottom: 5px">名称</p>
                    <el-input
                      size="small"
                      v-model="item.animation_name"
                      :disabled="isdisabled"
                      style="width: 630px"
                      class="namesAllStyle"
                    ></el-input>

                    <div style="margin-bottom: 10px; height: auto">
                      <p style="font-size: 13px; margin-bottom: 5px">描述</p>

                      <Toolbar
                        style="border-bottom: 1px solid #ccc; width: 630px"
                        :editor="editor"
                        :defaultConfig="toolbarConfig"
                        :mode="mode"
                      />
                      <Editor
                        class="editorWrap"
                        v-model="item.animation_des"
                        :defaultConfig="editorConfig"
                        :mode="mode"
                        @onCreated="onCreated"
                      />
                    </div>

                    <div style="margin-bottom: 10px; overflow: hidden; height: auto">
                      <p style="font-size: 13px; margin-bottom: 5px">图片及视频</p>
                      <div style="margin-bottom: 10px; overflow: hidden; height: auto">
                        <div
                          v-for="(items, index1) in item['animation_imagevideo_list']"
                          :key="index1"
                          class="imgVideoList"
                        >
                          <el-tooltip
                            class="item"
                            effect="dark"
                            :content="items.name"
                            placement="top"
                          >
                            <p style="font-size: 12px" class="imgTitle">{{ items.name }}</p>
                          </el-tooltip>

                          <img
                            v-if="
                              items.url.lastIndexOf('.jpg') !== -1 ||
                              items.url.lastIndexOf('.png') !== -1 ||
                              items.url.lastIndexOf('.gif') !== -1 ||
                              items.url.lastIndexOf('.jpeg') !== -1
                            "
                            :src="items.url"
                            alt=""
                            style="width: 90px; height: 80px"
                          />
                          <video
                            v-if="items.url.lastIndexOf('.mp4') !== -1"
                            :src="items.url"
                            controls
                            muted
                            autoplay="false"
                            style="width: 90px; height: 80px"
                          ></video>

                          <div class="downWrap">
                            <div class="preWrap">
                              <span
                                class="el-icon-zoom-in"
                                style="margin-right: 10px"
                                @click="preView(items)"
                              ></span>
                              <a class="el-icon-download" :href="items.url"></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div style="margin-bottom: 10px">
                      <p style="font-size: 13px; margin-bottom: 5px">附件</p>
                      <div>
                        <p v-for="(items, index1) in item['animation_annex_list']" :key="index1">
                          <a :href="items.url">
                            {{ items.name }}
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>

          <div v-if="this.isView !== '模型开发'" class="rejectStyle">
            <p class="modelName">驳回理由:</p>
            <div v-if="this.isView == '模型开发'">
              <el-input disabled type="textarea" v-model="viewDialogData.rejection"> </el-input>
            </div>
            <el-input
              v-else
              :disabled="isView == '模型申请'"
              type="textarea"
              v-model="viewDialogData.rejection"
            >
            </el-input>
          </div>

          <!-- <div style="overflow: hidden; margin-bottom: 10px">
            <v-data-table
              :headers="headers"
              :items="form.apply_list"
              hide-default-footer
              class="paginated-table table-striped table-hover"
              no-data-text="暂无数据"
            >
              <template v-slot:item.status="{ item }">{{ statusName(item.status) }}</template>
              <template v-slot:item.update_at="{ item }"
                ><span>{{ dateFormat(item.update_at) }}</span></template
              >
            </v-data-table>
          </div> -->
        </div>

        <v-card-actions class="btnWrapWrap">
          <div class="btnWrap">
            <v-btn color="success" v-if="isView == '需求审批'" :loading="btnLoading" @click="agree"
              >审 批 通 过</v-btn
            >
            <v-btn class="error" v-if="isView == '需求审批'" @click="reject">驳 回</v-btn>
            <v-btn color="success" v-if="isView == '模型审核'" @click="agree">审 核</v-btn>
            <v-btn class="error" v-if="isView == '模型审核'" @click="reject">驳 回</v-btn>
            <v-btn color="gray" elevation="2" @click="closeViewDialog">关闭</v-btn>
          </div>
        </v-card-actions>
        <v-snackbar v-model="snackbar" :timeout="timeout" top color="red">
          请填写驳回理由
        </v-snackbar>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="imgDialogVisible"
      width="800px"
      no-click-animation
      style="position: relative; z-index: 999"
    >
      <v-card elevation="2">
        <div style="overflow: hidden; height: auto">
          <span
            class="iconfont icon-shanchu2"
            @click="closePreImg"
            style="font-size: 20px; float: right; margin-right: 20px; cursor: pointer"
          ></span>

          <!-- <v-btn> 点击</v-btn> -->
          <!-- <v-btn density="compact" icon="close" style="color:#000;font-size:20px;"></v-btn> -->
          <!-- <v-icon
            small
            style="font-size: 30px; float: right; margin-right: 20px; cursor: pointer"
            @click.stop.prevent="closePreImg"
            >close</v-icon
          > -->
        </div>

        <div style="background: #fff; padding: 10px 10px; height: auto">
          <video
            v-if="diapreImg.lastIndexOf('.mp4') > -1"
            :src="diapreImg"
            :autoplay="false"
            muted
            controls
            height="600px"
            width="100%"
          ></video>
          <img v-else :src="diapreImg" alt="" height="600px" width="100%" />
        </div>
        <!-- <span class="iconfont download"></span> -->
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import Swal from 'sweetalert2';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import moment from 'moment';
import JSZip from 'jszip';
import FileSaver from 'file-saver';
import Axios from 'axios';
import JSZipUtils from 'jszip-utils';
import { left } from '@antv/x6/lib/registry/port-layout/line';
import { areaList } from '../../../../../api/user';
export default {
  components: {
    Editor,
    Toolbar,
  },
  props: {
    viewDialogVisible: {
      type: Boolean,
      default: false,
    },
    viewDialogData: {
      type: Object,
      default: {},
    },
    isView: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    activeName: 1,
    isdisabled: true,
    TreeData: [],
    requirement_device_type: [
      {
        id: 1,
        label: '设备',
        value: 'device',
      },
      {
        id: 2,
        label: '角色',
        value: 'role',
      },
      {
        id: 3,
        label: '工具',
        value: 'tool',
      },
      {
        id: 4,
        label: '场景',
        value: 'scene',
      },
    ],
    requirement_type: [
      {
        id: 1,
        label: '模型及动画',
        value: 'modelAnimation',
      },
      {
        id: 2,
        label: '视频',
        value: 'video',
      },
    ],
    requirement_modmajor_type: [],
    // formData: {
    //   activeNames1: '',
    //   activeNames2: '',
    //   activeNames3: '',
    //   activeNames4: '',
    //   modelTypeList: [
    //     {
    //       id: 1,
    //       label: '模型动画',
    //       value: 'modelAnimation',
    //     },
    //     {
    //       id: 2,
    //       label: '视频',
    //       value: 'video',
    //     },
    //   ],
    //   modelDeviceList: [
    //     {
    //       id: 1,
    //       label: '设备',
    //       value: 'device',
    //     },
    //     {
    //       id: 2,
    //       label: '角色',
    //       value: 'role',
    //     },
    //     {
    //       id: 3,
    //       label: '工具',
    //       value: 'tool',
    //     },
    //     {
    //       id: 4,
    //       label: '场景',
    //       value: 'scene',
    //     },
    //   ],
    // },
    // 模型类型下拉选项
    downLoading: false,
    imgDialogVisible: false,
    diapreImg: '',
    btnLoading: false,
    timeout: 2000,
    snackbar: false,
    btnStatus: [
      {
        id: '999',
        name: '全部',
        status: '999',
        colors: 'red',
      },
      {
        id: '8',
        name: '待审批',
        status: '8',
        colors: 'rgb(159,159,159)',
      },
      {
        id: '9',
        name: '待制作',
        status: '9',
        colors: 'rgb(159,159,159)',
      },
      {
        id: '10',
        name: '审批驳回',
        status: '10',
        colors: 'rgb(255, 125, 125)',
      },
      {
        id: '11',
        name: '制作中',
        status: '11',
        colors: 'rgb(0, 149, 255)',
      },
      {
        id: '12',
        name: '制作完成',
        status: '12',
        colors: 'rgb(76, 175, 80)',
      },
      {
        id: '14',
        name: '审核驳回',
        status: '14',
        colors: 'rgb(255, 125, 125)',
      },
    ],
    currentId: null,
    componentShow: true,
    checkNode: {},
    title: '',
    imgList: [],
    headers: [
      {
        text: '申请/驳回',
        align: 'center',
        value: 'status',
        sortable: false,
      },
      { text: '意见', align: 'center', value: 'remark', sortable: false },
      { text: '日期', align: 'center', value: 'update_at', sortable: false },
      { text: '操作人员', align: 'center', value: 'operator', sortable: false },
    ],
    editor: null,
    html: '<p>hello</p>',
    toolbarConfig: {},
    editorConfig: { placeholder: '请输入内容...' },
    mode: 'default', // or 'simple'
  }),
  methods: {
    async downAll() {
      let isNext = null;
      let result = await Swal.fire({
        title: '下载资源',
        text: `下载资源可能耗费较长时间,是否继续下载？`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
        reverseButtons: true,
      });
      if (result.value) {
        isNext = true;
      } else {
        isNext = false;
        return false;
      }
      if (!isNext) {
        return false;
      }

      let animationData = [];
      this.TreeData[0].requirement_animation.forEach((item, index) => {
        item.tag = '1997' + index;

        let arr = {
          name: item.animation_name,
          animation_imagevideo_list: [],
          animation_annex_list: [],
          tag: item.tag,
        };
        item.animation_imagevideo_list.forEach(items => {
          arr.animation_imagevideo_list.push({ name: items.name, url: items.url, tag: item.tag });
        });
        // item.animation_annex_list.forEach(items=>{  //动画需求附件
        //   items.name
        //   items.url
        // })

        animationData.push(arr);
      });

      this.animationUploadData('requirement_animation', animationData);

      // console.log(this.TreeData[0].requirement_imagevideo_list,'==========')
      // console.log(this.TreeData[0].requirement_annex,'=====附件=====')
      // console.log(this.TreeData[0].requirement_cad,'====尺寸图======')
      // console.log(this.TreeData[0].requirement_animation[0],'====尺寸图======')
      // this.TreeData[0].children.forEach(element => {
      //    console.log(item)
      //   //  item.component_imgvideo_list    //子部件视频及图片
      //   //  item.component_annex_list  //子部件附件

      // });
      let _this = this;
      this.downLoading = true;
      console.log('---------------------开始下载------------------------------------------');
      this.title = '需求资源开始下载';
      await this.forGetData(this.TreeData[0]);
      this.TreeData[0].requirement_imagevideo_list.forEach(item => {
        this.imgList.push({
          name: item.name,
          url: item.url,
        });
      });

      this.soureDown();
    },
    soureDown() {
      const zip1 = new JSZip();
      let _this = this;
      // 一个Promise数组，用于处理所有图片文件的添加
      const promises = this.imgList.map((url, index) => {
        // 使用一个唯一的文件名，例如添加序号
        // const uniqueFilename = `image_${index}.jpg`;
        return this.fetchAsBlob(url.url).then(blob => {
          zip1.file(url.name, blob);
        });
      });
      _this.title = '需求资源下载中';
      Promise.all(promises).then(() => {
        // 所有图片都已添加，现在生成zip文件
        const content = zip1.generateAsync({ type: 'blob' });
        content.then(blob => {
          console.log('---------------------下载完成------------------------------------------');
          _this.title = '需求资源下载完成';
          _this.downLoading = false;
          FileSaver.saveAs(blob, '需求资源.zip');
        });
      });
    },
    fetchAsBlob(url) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          } else {
            reject(new Error('Failed to fetch the file'));
          }
        };
        xhr.onerror = () => {
          reject(new Error('Network error'));
        };
        xhr.send();
      });
    },
    //递归拿树结构中图片视频url
    forGetData(data) {
      if (!data.children || data.children.length <= 0) {
        return;
      }
      data.children.forEach(item => {
        item.component_imgvideo_list.forEach(items => {
          this.imgList.push({
            name: items.name,
            url: items.url,
          });
        });
        this.forGetData(item);
      });
    },

    getImgArrayBuffer(url) {
      let _this = this;
      return new Promise((resolve, reject) => {
        //通过请求获取文件blob格式
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.open('GET', url, true);
        xmlhttp.responseType = 'blob';
        xmlhttp.onload = function () {
          if (this.status == 200) {
            resolve(this.response);
          } else {
            reject(this.status);
          }
        };
        xmlhttp.send();
      });
    },

    // 开始压缩
    async animationUploadData(type, animationData) {
      const zip1 = new JSZip();
      let _this = this;
      //动画开始下载
      this.title = '动画资源开始下载';
      let arr = [];
      if (type == 'requirement_animation') {
        animationData.forEach(item => {
          item.animation_imagevideo_list.forEach(items => {
            if (item.tag == items.tag) {
              let obj = {
                name: item.name,
                url: items.url,
                tagName: item.name,
                tag: item.tag,
              };
              arr.push(obj);
            }
          });
        });
      }
      if (arr.length <= 0) {
        return;
      }

      // 一个Promise数组，用于处理所有图片文件的添加
      const promises = arr.map((url, index) => {
        // 使用一个唯一的文件名，例如添加序号
        // const uniqueFilename = `image_${index}.jpg`;
        return this.fetchAsBlob(url.url).then(blob => {
          zip1.file(url.name, blob);
        });
      });
      this.title = '动画资源下载中';
      Promise.all(promises).then(() => {
        // 所有图片都已添加，现在生成zip文件
        const content = zip1.generateAsync({ type: 'blob' });
        content.then(blob => {
          console.log('---------------------下载完成------------------------------------------');
          _this.title = '动画资源下载完成';
          _this.downLoading = false;
          FileSaver.saveAs(blob, '动画资源.zip');
        });
      });
    },

    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      // console.log(this.editor)
      // this.editorRef =  editor
      editor.disable();
    },

    getImageName(url) {
      var regex = /[^/\\&?]+\.\w{3,4}(?=[\?&].*|$)/i;
      var match = url.match(regex);
      if (match) {
        let str = decodeURIComponent(match[0]);
        return str;
      }
      return null;
    },
    preView(data) {
      this.preImgFn(data);
    },
    aaa(node) {
      console.log(node);
    },
    //点击节点
    clickNode(node) {
      if (node.type && node.type == 'requirement') {
        this.componentShow = true;
      } else {
        this.componentShow = false;
        this.checkNode = node;
      }
    },

    // 添加节点
    append(data) {
      const newChild = {
        _id: this.uuid(),
        label: '子部件' + parseInt(data.children.length + 1), //部件名称
        component_des: '',
        component_imgvideo_list: [],
        component_annex_list: [],
        children: [],
      };
      if (!data.children) {
        data.children = [];
      }
      data.children.push(newChild);
      // TreeData = [...TreeData];
    },
    //删除节点
    remove(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d._id === data._id);
      children.splice(index, 1);
    },
    closePreImg() {
      this.imgDialogVisible = false;
    },
    preImgFn(data) {
      this.imgDialogVisible = true;
      this.diapreImg = data.url;
    },
    statusName(status) {
      let res = this.btnStatus.filter(item => item.status == status);
      return res[0].name;
    },
    closeViewDialog() {
      this.$emit('closeViewDialog');
    },
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    /**
     * 审批驳回
     */
    reject() {
      // --->DevMod
      if (this.viewDialogData.rejection == '') {
        this.snackbar = true;
        // this.showValue = 3;
        return;
      }
      let obj = {
        rejection: this.viewDialogData.rejection,
        option: this.viewDialogData.option || '',
        type: 'shenpiNo',
      };
      if (this.isView == '模型审核') {
        obj.type = 'shenheNo';
      } else {
        obj.type = 'shenpiNo';
      }

      this.$EventBus.$emit('handleReject', obj);
      // this.$emit('handleReject', { option: this.auditOpinion, rejection: this.rejection });
    },
    /**
     * 审批通过
     */
    agree() {
      // --->DevMod
      this.btnLoading = true;
      let obj = {
        rejection: this.viewDialogData.rejection,
        option: this.viewDialogData.option || '',
        type: 'shenpiSure',
      };
      if (this.isView == '模型审核') {
        obj.type = 'shenheSure';
      } else {
        obj.type = 'shenpiSure';
      }

      this.$EventBus.$emit('handleReject', obj);
    },
    /**
     * 生成uuid
     */
    uuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },

    /**
     * 初始化字典
     */
    initDict() {
      this.$dic.getCategoryList(
        {
          cate_type: this.viewDialogData.requirement_device_type || '',
          level: '1',
        },
        res => {
          this.requirement_modmajor_type = res;
        }
      );
    },
  },
  created() {
    console.log(this.viewDialogData);
    this.TreeData.push(this.viewDialogData);
    this.$nextTick(() => {
      this.currentId = this.viewDialogData._id;
      this.$refs.tree.setCurrentKey(this.currentId);
    });
    if (this.viewDialogData.requirement_device_type) {
      this.initDict();
    }
  },
  mounted() {},
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>

<style scoped>
.cardWrap {
  padding: 10px 20px;
}

.modelName {
  margin-right: 20px;
  margin-bottom: 0px;
}

.preImg {
  height: 100px;
  width: 150px;
  margin: 5px;
  padding: 0px;
}

.imgWrap > p {
  margin-bottom: 5px;
}

.imgWrap {
  margin: 5px 0;
}

.desWrap {
  color: #333;
  font-size: 14px;
  text-indent: 12px;
  background: #f9f9f9;
  padding: 0 5px;
}
h3 {
  margin: 0px 0px 10px 0px;
}
.btnWrap {
  width: 100%;
  text-align: right !important;
}
>>> .btnWrap .v-btn {
  margin: 0 10px;
}

.content {
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
}

/deep/#pubUpload .el-upload,
.el-upload--picture-card {
  width: 80px;
  height: 80px;
}
.uploadImg {
  width: 80px;
  height: 80px;
}

/deep/#pubUpload .el-upload-list__item,
.is-ready {
  width: 80px;
  height: 80px;
}

/deep/#onecollapse > .el-collapse-item__header {
  /* background-color: red  !important; */
  font-size: 18px;
}

/deep/#twocollapse > .el-collapse-item__header {
  /* background-color: red  !important; */
  font-size: 18px;
}

/deep/#threecollapse > .el-collapse-item__header {
  /* background-color: red  !important; */
  font-size: 18px;
}
/deep/#modelOne > .el-collapse-item__header {
  /* background-color: red  !important; */
  color: #005f27;
}
/deep/#modelTwo > .el-collapse-item__header {
  /* background-color: red  !important; */
  color: #005f27;
}

/deep/.el-upload-list .el-upload-list__item {
  margin-bottom: 0px !important;
}

.animation {
  margin-top: 20px;
}
.pubWrap {
  margin: 10px 0;
}

.items {
  width: auto;
  margin: 20px 10px 0px;
  padding: 10px 10px 10px;
  border: 1px solid #d3d0d0;
  border-radius: 5px;
  position: relative;
}

.itemTitle {
  width: 50px;
  position: absolute;
  top: -10px;
  background: #fff;
  height: 20px;
  left: 20px;
  font-size: 12px;
  text-align: center;
  margin: auto;
}

.rejectStyle {
  padding: 10px 10px;
  border: 1px solid #e1e1e1;
  margin-top: 10px;
  border-radius: 6px;
}

.rightPageOne {
  float: left;
  border-left: 1px solid #ddd4d4;
  width: 100%;
  overflow: hidden;
  height: auto;
  padding: 20px 10px;
}
.imgTitle {
  margin-bottom: 2px;
  width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  white-space: nowrap;
  height: 20px;
  line-height: 20px;
}
.el-main {
  padding: 10px;
}
.animationCon {
  position: relative;
  margin-bottom: 10px;
  border: 1px dashed #e1e1e1;
  padding: 10px;
  margin-top: 10px;
}
.animationTitle {
  position: absolute;
  top: 0px;
  left: 0px;
  color: red;
  background: #fff;
  top: -14px;
  left: 11px;
}
.imgVideoList {
  width: 90px;
  height: 100px;
  float: left;
  margin: 5px;
  border: 1px dashed #dddddd;
  position: relative;
}
.downWrap {
  /* margin: 10px 0; */
  position: absolute;
  bottom: -4px;
  left: 0;
  right: 0;
  height: 80px;
  width: 90px;
  display: none;
}

.imgVideoList:hover .downWrap {
  cursor: pointer;
  display: block;
  background: #494949a3;
}
.preWrap {
  color: #fff;
  font-size: 20px;
  transform: translateY(20px);
  text-align: center;
}
.preWrap a {
  color: #fff;
}
.preWrap a:hover {
  color: #fff !important;
}
.preWrap:hover a {
  color: #fff !important;
}
.describe >>> .el-textarea__inner {
  color: black !important;
}
.namesAllStyle >>> .el-input__inner {
  color: black !important;
}
.namesAllStyle >>> .el-input >>> .el-input__inner {
  color: black !important;
}

.editorWrap {
  height: auto;
  min-height: 200px;
  width: 630px;
}
@media (max-width: 600px) {
  .v-dialog--scrollable > .v-card > .btnWrapWrap {
    padding: 5px 5px 0px;
  }
  .btnWrap {
    margin-top: 6px;
    text-align: center;
  }

  .btnWrap .v-btn {
    margin: 0 5px;
    padding: 0 8px;
  }
  .editorWrap{
    width: 100%;
  }
}
</style>

<style src="@wangeditor/editor/dist/css/style.css"></style>
